






















































import { Component, Vue } from "vue-property-decorator";
import NavIcon from "./navigation/NavIcon.vue";
import { AuthModule } from "@/store/auth.module";
import { AuthService } from "@/services/auth.service";
import { DalModule } from "@/store/dal.module";
import { QuestionareModule } from "@/store/questionary.module";
import { Questionnaire, QuestionnaireDetails } from "~/dal/questionare";

@Component({
  components: {
    NavIcon,
  },
  watch: {
    //account_id: "accountChanged",
  },
})
export default class ApNavigation extends Vue {
  get account_id() {
    return DalModule.AccountId;
  }
  set account_id(val) {
    this.clickAcc(val);
  }

  clickAcc(account_id: number) {
    this.$router.push({
      name: "account-info",
      params: { id: account_id.toString() },
    });
  }

  get isLoggedIn() {
    return AuthModule.isLoggedIn;
  }
  get user() {
    return AuthModule.user as IUser;
  }

  get fullName() {
    return `${this.user.firstname} ${this.user.lastname} ${
      this.user.middlename ? this.user.middlename : ""
    }`;
  }

  get userName() {
    const un = this.fullName;
    if (un.length >= 20) {
      const slice = un.slice(0, 17);
      return slice + "...";
    }
    return un;
  }

  goToContracts() {
    this.$router.push({
      name: "account-list",
    });
  }

  logout() {
    AuthService.logout();
  }

  get accounts() {
    return DalModule.accounts;
  }

  async mounted() {
    await DalModule.getAccounts();
    if (this.accounts.length > 0) {
      this.account_id = this.accounts[0].account_id;
    }
    if (AuthModule.user && AuthModule.user.userid) {
      await QuestionareModule.getQuestionnaire();
      QuestionareModule.questionsList.forEach((element: Questionnaire) => {
        element.rqd.forEach(r => {
          r.checked = null as any;
          r.text = null as any;
        });
      });
    }
  }

}
